<router-outlet></router-outlet>
<snackbar-cmp></snackbar-cmp>